<template>
  <component :is="tag" :class="componentClasses">
    <slot />
  </component>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  tag: {
    type: String,
    default: 'h3',
  },
  size: {
    type: String,
  },
});

const componentClasses = computed(() => [
  'stk-subtitle',
  props.size ? `stk-size-${props.size}` : '', // Add size class if 'size' is defined
]);
</script>

<style>
.stk-subtitle {
  color: var(--stk-text-normal);
  font-weight: 500;
  line-height: 1.125;
}
</style>
